<template>
  <section-page
    title="End of Day Report"
    is-short
  >
    <template v-if="hasAdvancedReportingFeature">
      <div class="mb-200">
        <p>
          Get a daily email that lets you know everything that has happened inside
          Forefront that day including records created, appointments set, follow-ups made, and communications made.
        </p>
      </div>

      <div class="columns mx-25">
        <form-field-select
          class="mr-100"
          label="Send End of Day Report"
          v-model="isSendingReport"
        >
          <option :value="true">Yes</option>
          <option :value="false">No</option>
        </form-field-select>

        <form-field-time-picker
          label="Time Report Is Sent"
          type="time"
          v-model="form.send_end_of_day_report_at"
          :disabled="!isSendingReport"
        ></form-field-time-picker>
      </div>

      <div class="flex flex-end">
        <button-default
          :loading="isSaving"
          @click="save"
        >
          Update
        </button-default>
      </div>
    </template>

    <div v-else class="upgrade_message">
      <p class="upgrade_message--content"><a @click="openBillingPortal">Upgrade your account today</a> and gain access to
        end of day report.</p>
      <p class="upgrade_message--content">Get a daily email that lets you know everything that has happened inside
        Forefront that day including records created, appointments set, follow-ups made, and communications made.</p>

      <button-outlined
        class="upgrade_message--button"
        @click="openBillingPortal"
        size="">Upgrade Your Account Now
      </button-outlined>
    </div>
  </section-page>
</template>

<script>
import {FormMixin} from "../../../forms/forms.mixin";
import dates from "../../../services/dates";

export default {
  name: 'ProfileEndOfDayReport',
  mixins: [FormMixin],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isSendingReport: false,
      isSaving: false,
      form: {},
      defaultForm: {
        id: this.user.id,
        send_end_of_day_report_at: dates.getTodayTime(17),
      }
    }
  },
  mounted() {
    this.initForm();
  },
  computed: {
    hasAdvancedReportingFeature() {
      return this.$store.getters.account.has_advanced_reporting_feature;
    },
  },
  methods: {
    initForm() {
      this.form = this.$utils.clone(this.defaultForm);

      if (this.user.send_end_of_day_report_at !== null) {
        this.isSendingReport = true;
        this.form.send_end_of_day_report_at = this.user.send_end_of_day_report_at.split('T')[1];
      }
    },
    update() {
      let payload = {
        id: this.form.id,
        send_end_of_day_report_at: (this.isSendingReport) ? this.form.send_end_of_day_report_at : null
      };

      return this.$api.users.updateEndOfDayReport(payload)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Updated End of Day Report Setting",
            type: 'is-success'
          });

          return res;
        });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.upgrade_message {

  &--content {
    margin-bottom: 10px;
    line-height: 1.4;

    a {
      font-weight: bold;
    }
  }

  &--button {
    margin: 1rem 0;
  }
}
</style>
